import { HttpClient } from './HttpClient.js';


export const LoginService = {
    async login(form) {
        return await HttpClient.post('/login', form).then(response => response);
    },

    async get2FACode() {
        return await HttpClient.get('/user/enable-2fa').then(response => response);
    },

    async validate2FA(code) {
        // Keep the exact six digits, including leading and trailing zeros.
        if (typeof code !== 'string' || !/^[0-9]{6}$/.test(code)) {
            throw new Error('El código debe contener exactamente 6 dígitos.');
        }
        return await HttpClient.get(`/user/validate-2fa/${code}`).then(response => response);
    }

}
